import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import { ReactComponent as PlainIcon } from '../../assets/svg/plane_up.svg';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';
import { formatDateRange, getUniqueConfirmationNumbers, getRouteType } from '../../utils/common';
import useStyles from './index.style';

const FlightSummary = ({ guestNames, guestFlights }) => {
  const classes = useStyles();
  const {
    data: { localizedDayjs },
  } = useGlobal();
  const getDictionary = useDictionary(Dictionary);

  const routeTypeName = {
    roundtrip: getDictionary(Dictionary.airFlightTypeRoundtrip.key),
    oneWay: getDictionary(Dictionary.airFlightTypeOneWay.key),
    multiCity: getDictionary(Dictionary.airFlightTypeMultiCity.key),
  };

  const routeType = getRouteType(guestFlights, routeTypeName);

  const { flightSegments = [] } = guestFlights[0];
  const outboundDeparDate = guestFlights[0]?.departDate;
  const inboundDeparDate = guestFlights[routeType === routeTypeName.oneWay ? 0 : 1]?.departDate;

  const uniqueConfirmationNumbers = getUniqueConfirmationNumbers(guestFlights);

  const { startDate, endDate } = formatDateRange(
    outboundDeparDate,
    inboundDeparDate,
    localizedDayjs,
  );

  const getFlightDates = () => (endDate !== '' ? `${startDate} - ${endDate}` : startDate);

  return (
    <Box className={classes.flightSummary}>
      <PlainIcon className="icon" />
      <div>
        <span className="label flight-dates">{getFlightDates()}</span>
        <div className="summary-items">
          <span>
            {routeType}{' '}
            {`${flightSegments[0]?.departure?.airport?.code} - ${
              flightSegments[flightSegments.length - 1]?.arrival?.airport?.code
            }`}
          </span>
          <span>
            {' '}
            {getDictionary(Dictionary.airPassengersLabel.key)} {guestNames.length}
          </span>
          <span className="confirmation">
            {getDictionary(Dictionary.airFlightDetailsConfirmationLabel.key)}{' '}
            {uniqueConfirmationNumbers.join(', ')}
          </span>
        </div>
      </div>
    </Box>
  );
};

FlightSummary.propTypes = {
  guestFlights: PropTypes.arrayOf(
    PropTypes.shape({
      arrivalDate: PropTypes.string,
      confirmationNumbers: PropTypes.arrayOf(PropTypes.string),
      departDate: PropTypes.string,
      flightIcon: PropTypes.string,
      gdsLocator: PropTypes.string,
      numberOfStops: PropTypes.number,
      routeDirection: PropTypes.string,
      totalDurationMins: PropTypes.number,
      flightSegments: PropTypes.arrayOf(
        PropTypes.shape({
          durationMins: PropTypes.number,
          layoverMins: PropTypes.number,
          number: PropTypes.string,
          arrival: PropTypes.shape({
            date: PropTypes.string,
            time: PropTypes.string,
            airport: PropTypes.shape({
              code: PropTypes.string,
              name: PropTypes.string,
            }),
          }),
          departure: PropTypes.shape({
            date: PropTypes.string,
            time: PropTypes.string,
            airport: PropTypes.shape({
              code: PropTypes.string,
              name: PropTypes.string,
            }),
          }),
        }),
      ),
    }),
  ),
};

export default FlightSummary;
